module.exports = __webpack_public_path__ + "static/sport_high-f57b0b2e6251da088c085310304630f9.mp4";